import { Box } from '@mui/material';
import logos from '../../assets/images/footer-logos.png';
import './styles.css';
import { useLocation, useNavigate } from 'react-router-dom';
import React from 'react';
import { useAccessibility } from '../../Store/contexts/AccessibilityContext';

interface FooterProps {
  showMapaDoSite?: boolean
}

const Footer: React.FC<FooterProps> = ({ showMapaDoSite }) => {
  const location = useLocation();
  const naviagate = useNavigate();

  const { contrastStyle, calculateTextStyle } = useAccessibility();
  return (
    <>
      <Box
        style={contrastStyle}
        component="footer"
        className={`footer-container ${location.pathname !== '/login' && 'footer-container-system'}`}
      >
        <div className='footer-box-text'>
          {showMapaDoSite && <span
            style={{ ...calculateTextStyle(12) }}
            className='footer-text footer-text-link'
            onClick={() => naviagate('/mapaDoSite')}
            tabIndex={0}
          >Mapa do site</span>}
          <span style={{ ...calculateTextStyle(12), background: '', backgroundColor: '' }} className='footer-text'>
            Copyright © {new Date().getFullYear()} Unimed Campinas - Todos os direitos reservados CNPJ 46.124.624.0001-11
          </span>
        </div>
        {location.pathname === '/login' && (
          <div>
            <img src={logos} alt="Logos" className='img-footer-logos' />
          </div>
        )}
      </Box>
    </>
  );
}

export default Footer;
